import CustomFileInput from "../../../components/customFileInput";
import Input from "../../../components/input";


const UploadCampaignImage = ({
    videoLinkName, videoLinkValue, videoLinkOnChange, videoLinkOnError, videoLinkOnBlur,
    onImageSelect
  }) => {

  const handleFileChange = (files) => {
    const selectedFile = files ? files[0] : null;
    if (onImageSelect) {
      onImageSelect(selectedFile);
    }
  };

      
    return (
      <div>
  
        <div className="grid mt-4 mb-8">
          <span className="font-semibold">Step 3 of 5</span>
          <span className="text-secondary text-sm">
            An emotionally engaging image / video boosts your chances of receiving donations.
          </span>
        </div>
        <div className="grid gap-4 mb-8 md:w-1/2">
           <CustomFileInput
              label="Upload your main campaign image*"
              onFileChange={handleFileChange}
            />
          <div>
            <Input
              label={"Video link [Optional]"}
              placeholder={"https://www.youtube.com/my-video-link"}
              name={videoLinkName}
              value={videoLinkValue}
              onChange={videoLinkOnChange}
              onBlur={videoLinkOnBlur}
              onError={videoLinkOnError}
            />
          </div>
        </div>
      </div>
    );
}
 
export default UploadCampaignImage;